import React from "react";

export const SortSvg = ({ direction = null, onAsc, onDesc }) => {
  const inactive = "#6A7282";
  const active = "#1447E6";

  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ flexShrink: 0, display: "block" }}
    >
      {/* Up arrow → ascending */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.58756 2.50418C6.81537 2.27638 7.18471 2.27638 7.41252 2.50418L9.74585 4.83752C9.97366 5.06532 9.97366 5.43467 9.74585 5.66247C9.51805 5.89028 9.1487 5.89028 8.9209 5.66247L7.00004 3.74162L5.07919 5.66247C4.85138 5.89028 4.48203 5.89028 4.25423 5.66247C4.02642 5.43467 4.02642 5.06532 4.25423 4.83752L6.58756 2.50418Z"
        fill={direction === "asc" ? active : inactive}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          onAsc?.(e);
        }}
      />
      {/* Down arrow → descending */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25423 8.33752C4.48203 8.10971 4.85138 8.10971 5.07919 8.33752L7.00004 10.2584L8.9209 8.33752C9.1487 8.10971 9.51805 8.10971 9.74585 8.33752C9.97366 8.56532 9.97366 8.93467 9.74585 9.16247L7.41252 11.4958C7.18471 11.7236 6.81537 11.7236 6.58756 11.4958L4.25423 9.16247C4.02642 8.93467 4.02642 8.56532 4.25423 8.33752Z"
        fill={direction === "desc" ? active : inactive}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          onDesc?.(e);
        }}
      />
    </svg>
  );
};
